/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { UpdateCardHolder200ResponseAvailableMerchantCategoriesInner } from './update-card-holder200-response-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateCardHolder200ResponseReissue } from './update-card-holder200-response-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateCardHolder200ResponseUser } from './update-card-holder200-response-user';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateCardHolder200ResponseUserAccountGroup } from './update-card-holder200-response-user-account-group';

/**
 * 
 * @export
 * @interface UpdateCardHolder200Response
 */
export interface UpdateCardHolder200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCardHolder200Response
     */
    'availableCurrencies': Array<UpdateCardHolder200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<UpdateCardHolder200ResponseAvailableMerchantCategoriesInner>}
     * @memberof UpdateCardHolder200Response
     */
    'availableMerchantCategories': Array<UpdateCardHolder200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {UpdateCardHolder200ResponseUser}
     * @memberof UpdateCardHolder200Response
     */
    'user': UpdateCardHolder200ResponseUser;
    /**
     * 
     * @type {UpdateCardHolder200ResponseUserAccountGroup}
     * @memberof UpdateCardHolder200Response
     */
    'userAccountGroup'?: UpdateCardHolder200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200Response
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {UpdateCardHolder200ResponseReissue}
     * @memberof UpdateCardHolder200Response
     */
    'reissue'?: UpdateCardHolder200ResponseReissue | null;
}

export const UpdateCardHolder200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateCardHolder200ResponseAvailableCurrenciesEnum = typeof UpdateCardHolder200ResponseAvailableCurrenciesEnum[keyof typeof UpdateCardHolder200ResponseAvailableCurrenciesEnum];


